import { API_URL } from "@/constants/envVariables";

import { handleApiResponse } from "@/api/handleApiResponse";

import { buildAuthHeaders, getAuthCredentials } from "@/helpers/authHeaders";

import { DisbursementStatusType } from "@/types";

export const patchDisbursementStatus = async (
  token: string,
  disbursementId: string,
  status: DisbursementStatusType,
): Promise<{ message: string }> => {
  const response = await fetch(`${API_URL}/disbursements/${disbursementId}/status`, {
    method: "PATCH",
    credentials: getAuthCredentials(),
    headers: {
      "Content-Type": "application/json",
      ...buildAuthHeaders(token),
    },
    body: JSON.stringify({
      status,
    }),
  });

  return handleApiResponse(response);
};
